// client/src/components/configuracoes/integracoes/EvolutionQrCodeModal.js
import React, { useEffect } from 'react';
import { X, Loader2, CheckCircle2 } from 'lucide-react';
import { useQueryClient } from '@tanstack/react-query';
import { useStatusEvolution } from '../../../hooks/useIntegracoes';
import useAlert from '../../../hooks/useAlert';

// ✅ Modal de pareamento WhatsApp via Evolution API — mostra o QR Code
// inicial (devolvido por useConectarEvolution, quem abre este modal) e faz
// polling de status (useStatusEvolution) até a conexão ser confirmada
// ('ativo'), fechando sozinho e avisando via useAlert() (nunca alert()
// nativo, ver client/CLAUDE.md).
const EvolutionQrCodeModal = ({ qrCodeInicial, onClose }) => {
    const { setAlert } = useAlert();
    const queryClient = useQueryClient();
    const { data, isLoading } = useStatusEvolution(true);

    const status = data?.status;
    const qrCode = data?.qrCode || qrCodeInicial;

    // TanStack Query v5 não tem onSuccess em useQuery — reage à mudança de
    // status aqui. Ao conectar, invalida o GET genérico da integração
    // (useIntegracao('whatsapp')) pro card fora do modal atualizar sem
    // precisar de reload, avisa e fecha.
    useEffect(() => {
        if (status === 'ativo') {
            queryClient.invalidateQueries({ queryKey: ['integracoes', 'whatsapp'] });
            setAlert('WhatsApp conectado com sucesso!', 'success');
            onClose();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status]);

    return (
        <div
            style={{
                position: 'fixed', inset: 0, zIndex: 1000,
                background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                padding: '1rem',
            }}
            onClick={onClose}
        >
            <div
                style={{
                    background: '#fff', borderRadius: 12, padding: '1.5rem', maxWidth: 380, width: '100%',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.2)', textAlign: 'center',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
                    <h3 className="form-title" style={{ margin: 0 }}>Conectar WhatsApp</h3>
                    <button onClick={onClose} className="form-close-button" title="Fechar">
                        <X size={20} />
                    </button>
                </div>

                {status === 'ativo' ? (
                    <div style={{ padding: '2rem 0' }}>
                        <CheckCircle2 size={48} color="#16a34a" />
                        <p style={{ marginTop: '0.75rem' }}>Conectado com sucesso!</p>
                    </div>
                ) : qrCode ? (
                    <>
                        <img
                            src={qrCode.startsWith('data:') ? qrCode : `data:image/png;base64,${qrCode}`}
                            alt="QR Code do WhatsApp"
                            style={{ width: '100%', maxWidth: 280, margin: '0 auto', borderRadius: 8, border: '1px solid #e5e7eb' }}
                        />
                        <p style={{ fontSize: '0.85rem', color: '#475569', marginTop: '1rem' }}>
                            Abra o WhatsApp no celular que vai atender esta conta, toque em <strong>Aparelhos conectados → Conectar um aparelho</strong> e escaneie o código acima.
                        </p>
                        <p style={{ fontSize: '0.75rem', color: '#475569', marginTop: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                            <Loader2 size={14} className="animate-spin" /> Aguardando escaneamento...
                        </p>
                    </>
                ) : (
                    <div style={{ padding: '2rem 0' }}>
                        <Loader2 size={32} className="animate-spin" />
                        <p style={{ marginTop: '0.75rem' }}>{isLoading ? 'Carregando QR Code...' : 'QR Code indisponível — feche e tente novamente.'}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default EvolutionQrCodeModal;
